import { Component, ElementRef, Input, AfterViewInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements AfterViewInit, OnChanges {
    @Input() value: number = 0;
    @Input() max: number = 100;
    @ViewChild('progressBar') progressBarRef!: ElementRef;

    parentWidth: number = 0;
    completedWidth: number = 0;

    ngAfterViewInit() {
        this.updateCompletedWidth();
    }

    ngOnChanges(changes: SimpleChanges) {
        if ((changes['value'] || changes['max']) && this.progressBarRef) {
            this.updateCompletedWidth();
        }
    }

    private updateCompletedWidth() {
        if (this.progressBarRef?.nativeElement) {
            this.parentWidth = this.progressBarRef.nativeElement.offsetWidth;
            this.completedWidth = (this.value / this.max) * this.parentWidth;
        }
    }
}